module.exports = __webpack_public_path__ + "assets/img/favicon/apple-icon-60x60.b830da6f0d990f5489890e3d811ff4e5.png";